import { __assign, __rest } from "tslib";
import { connect } from 'react-redux';
import { highlightComment, unHighlightComment } from '../actionCreators';
import { positionAnnotation } from '../actionCreators/annotation';
import Annotation from '../components/Annotation';
import { isDehighlighted, isHighlighted, isMoveable, isPulsing, } from '../selectors/annotation';
import { getHotspotStyle } from '../selectors/layout';
function mapStateToProps(state, _a) {
    var location = _a.location, screenID = _a.screenID, annotation = __rest(_a, ["location", "screenID"]);
    var _b = getHotspotStyle({
        hotspot: annotation,
        state: state,
        location: location,
        screenID: screenID,
    }), top = _b.top, left = _b.left;
    var commentUUID = annotation.commentUUID;
    return __assign(__assign({}, annotation), { position: { top: top, left: left }, isHighlighted: isHighlighted(state, commentUUID), isDehighlighted: isDehighlighted(state, commentUUID), isPulsing: isPulsing(state, commentUUID), isMoveable: isMoveable(state, annotation) });
}
function mapDispatchToProps(dispatch, ownProps) {
    return {
        onDrop: function (dropPosition) {
            dispatch(positionAnnotation(ownProps.commentUUID, ownProps.screenArea, dropPosition));
        },
        onMouseEnter: function () {
            dispatch(highlightComment(ownProps.commentUUID));
        },
        onMouseLeave: function () {
            dispatch(unHighlightComment(ownProps.commentUUID));
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Annotation);
